if (!customElements.get('quarter-stories')) {
  customElements.define(
    'quarter-stories',
    class QuarterStories extends HTMLElement {
      constructor() {
        super();

        this.tabs = Array.from(this.querySelectorAll('.quarter-stories__tab'));
        this.wedges = Array.from(this.querySelectorAll('.quarter-stories__wedge'));
        this.stories = Array.from(this.querySelectorAll('.quarter-stories__story'));
        this.panelbox = this.querySelector('.quarter-stories__panelbox');

        if (this.stories.length === 0) return;

        this.paused = false;
        this.interval = null;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.mobileQuery = window.matchMedia('(max-width: 959px)');

        this.tabs.forEach((tab) => {
          tab.addEventListener('click', () => {
            this.pause();
            this.setActive(tab.dataset.key, true);
          });
        });

        this.wedges.forEach((wedge) => {
          wedge.addEventListener('click', () => {
            this.pause();
            this.setActive(wedge.dataset.key, true);
          });
          wedge.addEventListener('keydown', (event) => {
            if (event.key === 'Enter' || event.key === ' ') {
              event.preventDefault();
              this.pause();
              this.setActive(wedge.dataset.key, true);
            }
          });
        });

        this.addEventListener('pointerdown', () => this.pause());

        if (this.panelbox) {
          this.panelbox.addEventListener('scroll', this.onPanelboxScroll.bind(this), { passive: true });
        }

        if (!this.reducedMotion) {
          this.startAutoAdvance();
        }
      }

      setActive(key, scrollIntoView) {
        this.tabs.forEach((tab) => {
          const isActive = tab.dataset.key === key;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', isActive);
        });

        this.wedges.forEach((wedge) => {
          wedge.classList.toggle('is-on', wedge.dataset.key === key);
        });

        this.stories.forEach((story) => {
          story.classList.toggle('is-active', story.dataset.key === key);
        });

        if (scrollIntoView && this.mobileQuery.matches && this.panelbox) {
          const story = this.stories.find((story) => story.dataset.key === key);
          if (story) story.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        }
      }

      onPanelboxScroll() {
        if (!this.mobileQuery.matches) return;
        window.clearTimeout(this.scrollTimeout);
        this.scrollTimeout = window.setTimeout(() => {
          const boxRect = this.panelbox.getBoundingClientRect();
          const center = boxRect.left + boxRect.width / 2;
          let closest = null;
          let closestDistance = Infinity;
          this.stories.forEach((story) => {
            const rect = story.getBoundingClientRect();
            const distance = Math.abs(rect.left + rect.width / 2 - center);
            if (distance < closestDistance) {
              closestDistance = distance;
              closest = story;
            }
          });
          if (closest) this.setActive(closest.dataset.key, false);
        }, 100);
      }

      startAutoAdvance() {
        this.interval = window.setInterval(() => {
          if (this.paused || this.mobileQuery.matches) return;
          const activeIndex = this.stories.findIndex((story) => story.classList.contains('is-active'));
          const nextIndex = (activeIndex + 1) % this.stories.length;
          this.setActive(this.stories[nextIndex].dataset.key);
        }, 5500);
      }

      pause() {
        if (this.paused) return;
        this.paused = true;
        if (this.interval) {
          window.clearInterval(this.interval);
          this.interval = null;
        }
      }
    }
  );
}
